import styled from 'styled-components';

export const StyledNoStyleButton = styled.div`
  cursor: pointer;
  height: 100%;
`;
